import { isStagingHostname } from "@solomon-apps/config/environment";

/** Injected as an esbuild define by scripts/build/esbuild.mjs ("production"
 *  for builds, "development" for watch/serve). Undeclared under vitest/node —
 *  the `typeof` guard below makes that read as non-production. */
declare const __BUILD_MODE__: string | undefined;

/**
 * True in production bundles. Gate dev-only surfaces (sim mode, design
 * showcases) on this — the comparison folds to a constant at build time, so
 * the gated code is dead-code-eliminated from production bundles.
 */
export const IS_PRODUCTION_BUILD: boolean = typeof __BUILD_MODE__ !== "undefined" && __BUILD_MODE__ === "production";

/**
 * Check if the current host is a production Solomon deployment.
 */
export function isProductionHost(): boolean {
    if (typeof window === "undefined") {
        return false;
    }
    return window.location.hostname.endsWith(".solomonlabs.org");
}

export type DeployEnv = "production" | "staging" | "local";

/**
 * Classify the current host into a deploy environment.
 * Returns null for unknown hosts (e.g. ad-hoc Netlify deploy previews) so
 * analytics/observability stay opt-in by domain.
 */
export function detectDeployEnv(): DeployEnv | null {
    if (typeof window === "undefined") {
        return null;
    }
    const host = window.location.hostname;
    if (host.endsWith(".solomonlabs.org")) {
        return "production";
    }
    if (isStagingHostname(host)) {
        return "staging";
    }
    if (host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0") {
        return "local";
    }
    return null;
}
